import { DataBean } from "../DataBean";

export class BusinessCoreForAccountant extends DataBean {


    public async importBusinessCoreForAccountantID(idAccountantIDType:any,filename:any,directory:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importBusinessCoreForAccountantID_Number_String_String_String", [idAccountantIDType,filename,directory,dataStore]);
    }


}